module.exports = __webpack_public_path__ + "static/media/instagramBig.b994019a.png";